export default __webpack_public_path__ + "static/media/note_taker.cf8614c0.png";